import { useContext, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import useLogout from '../../api/hooks/authentication/useLogout';
import useUser from '../../api/hooks/useUser';
import LogMessage from '../../components/misc/LogMessage';
import MyNavigator from '../../components/misc/MyNavigator';
import NavBar from '../../components/misc/NavBar';
import SideBar from '../../components/misc/SideBar';
import DeleteModal from '../../components/modals/DeleteModal';
import LogoutModal from '../../components/modals/LogoutModal';
import SettingsCreateUserModal from '../../components/settings/SettingsCreateUserModal';
import SettingsEditModal from '../../components/settings/SettingsEditProfileModal';
import UsersTable from '../../components/user/UsersTable';
import { logMsgBgColors } from '../../consts/misc';
import { toIcons } from '../../consts/Paths';
import { possible_statuses } from '../../consts/possible_statuses';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import useLogMessage from '../../hooks/useLogMessage';
import useToggle from '../../hooks/useToggle';
import '../../styles/Settings.css';
import Categories from '../../components/user/Categories';
import SettingsCreateCategoryModal from '../../components/settings/SettingsCreateCategoryModal';
import Sites from '../../components/user/Sites';
import SettingsCreateSiteModal from '../../components/settings/SettingsCreateSiteModal';
import PaymentRules from '../../components/user/PaymentRules';
import SettingsCreatePaymentRulesModal from '../../components/settings/SettingsCreatePaymentRulesModal';
import SettingsCreateShippingRulesModal from '../../components/settings/SettingsCreateShippingRulesModal';
import ShippingRules from '../../components/user/ShippingRules';
import ReturnRules from '../../components/user/ReturnRules';
import SettingsCreateReturnRulesModal from '../../components/settings/SettingsCreateReturnRulesModal';
import SettingsCreateConditionsModal from '../../components/settings/SettingsCreateConditionsModal';
import ChangeSites from '../../components/user/ChangeSites';
import ContoVendita from '../../components/user/ContoVendita';
import Conditions from '../../components/user/Conditions';
import Suppliers from '../../components/user/Supplier';
import SettingsCreateSupplierModal from '../../components/settings/SettingsCreateSupplierModal';
import Manufacturers from '../../components/user/Manufacturers';
import SettingsCreateManufacturersModal from '../../components/settings/SettingsCreateManufacturersModal';
import Vendors from '../../components/user/Vendors';
import SettingsCreateVendorModal from '../../components/settings/SettingsCreateVendorModal';
import useSecurityCheck from '../../api/hooks/useSecurityCheck';

const SettingsPage = (props: any) => {
    const { user, userTreated, setUserTreated } = useContext(MainContext);
    const logMessage = useLogMessage();
    const { isMobile } = useIsMobile();
    const resetListToggler = useToggle(false);
    const menuToggler = useToggle(false);
    const navigateNow = useToggle(false);
    const logoutToggler = useToggle(false);
    const isAdmin = useMemo(() => user?.roles?.find((e) => e.role === possible_statuses.userType.admin), [user?.roles]);
    const role = useMemo(() => (user?.roles?.find((e: any) => e.role === possible_statuses.userType.admin) ? 'Admin' : 'Normal'), [props.user?.roles]);
    const [securityCheckEnabled, setSecurityCheckEnabled] = useState(false);

    /* modals */
    const editProfileModalToggler = useToggle(false);
    const createUserModalToggler = useToggle(false);
    const deleteUserModalToggler = useToggle(false);
    const createCategoryModalToggler = useToggle(false);
    const createSiteModalToggler = useToggle(false);
    const createPaymentRulesModalToggler = useToggle(false);
    const createShippingRulesModalToggler = useToggle(false);
    const createReturnRulesModalToggler = useToggle(false);
    const createConditionModalToggler = useToggle(false);
    const createSupplierModalToggler = useToggle(false);
    const createManufacturersModalToggler = useToggle(false);
    const createVendorModalToggler = useToggle(false);
    /*  */

    const anyModalOpen =
        editProfileModalToggler.isToggled ||
        createUserModalToggler.isToggled ||
        createCategoryModalToggler.isToggled ||
        deleteUserModalToggler.isToggled ||
        createPaymentRulesModalToggler.isToggled ||
        createShippingRulesModalToggler.isToggled ||
        createReturnRulesModalToggler.isToggled ||
        createConditionModalToggler.isToggled ||
        createSupplierModalToggler.isToggled ||
        createManufacturersModalToggler.isToggled ||
        createVendorModalToggler.isToggled;

    const deleteUserForm = useForm();

    const { RESPONSES, RESULTS, CTAs } = useUser();
    const { RESPONSES: RESPONSEsecurity, RESULTS: RESULTSsecurity, CTAs: CTASsecurity } = useSecurityCheck();

    const tempLoading = useToggle(false);

    useEffect(() => {
        CTASsecurity?.getSecurityCheck();
    }, []);

    useEffect(() => {
        if (RESPONSEsecurity.getSecurityCheckResponse?.ok) {
            const isEnabled = RESULTSsecurity?.getSecurityCheckResult?.enabled === 1 || RESULTSsecurity?.getSecurityCheckResult?.enabled === "1"  ? true : false;
            setSecurityCheckEnabled(isEnabled);
        }
    }, [RESPONSEsecurity.getSecurityCheckResponse]);

    const submitSecurityCheck = (value: any) => {
        CTASsecurity?.createSecurityCheck(value);
        setSecurityCheckEnabled(value);
    };

    useEffect(() => {
        if (tempLoading.isToggled) {
            /* caricamento */
            logMessage.setMessageTimer(20000);
            logMessage.write('subject', 'Loading . . .');
            logMessage.write('bgColor', logMsgBgColors.loading);
        } else if (!tempLoading.isToggled) {
            logMessage.setMessageTimer(null);
        }
    }, [tempLoading.isToggled]);

    const onDeleteUserSubmit = (data: any) => {
        tempLoading.setIsToggled(true);
        const id = data.id;
        CTAs.deleteUser(id);
    };

    useEffect(() => {
        /* console.log(RESPONSES.deleteResponse, RESULTS.deleteResult); */
        if (RESPONSES.deleteResponse?.ok) {
            tempLoading.setIsToggled(false);
            logMessage.write('subject', `${userTreated?.name ? userTreated.name : ''} ${userTreated?.surname ? userTreated.surname : ''}`);
            logMessage.write('other_text', ' deleted succesffuly!');
            logMessage.write('bgColor', logMsgBgColors.correct);
            deleteUserModalToggler.toggle();
            resetListToggler.toggle();
        } else if (RESPONSES.deleteResponse?.ok === false) {
            tempLoading.setIsToggled(false);
            logMessage.write('subject', 'User');
            logMessage.write('other_text', 'could not be deleted');
            logMessage.write('bgColor', logMsgBgColors.error);
        }
    }, [RESPONSES.deleteResponse]);

    useEffect(() => {
        if (editProfileModalToggler.isToggled) {
            createUserModalToggler.toggle();
        } else if (createUserModalToggler.isToggled) {
            editProfileModalToggler.toggle();
        } else if (createCategoryModalToggler.isToggled) {
            createCategoryModalToggler.toggle();
        } else if (createSiteModalToggler.isToggled) {
            createSiteModalToggler.toggle();
        } else if (createPaymentRulesModalToggler.isToggled) {
            createPaymentRulesModalToggler.toggle();
        } else if (createShippingRulesModalToggler.isToggled) {
            createShippingRulesModalToggler.toggle();
        } else if (createReturnRulesModalToggler.isToggled) {
            createReturnRulesModalToggler.toggle();
        } else if (createConditionModalToggler.isToggled) {
            createConditionModalToggler.toggle();
        } else if (createSupplierModalToggler.isToggled) {
            createSupplierModalToggler.toggle();
        } else if (createVendorModalToggler.isToggled) {
            createVendorModalToggler.toggle();
        }
    }, []);

    useEffect(() => {
        if (user === null && window.location.pathname.includes('/settings')) {
            navigateNow.setIsToggled(true);
        }
    }, []);

    return (
        <div className='page-wrapper'>
            {logoutToggler.isToggled && <LogoutModal toggler={logoutToggler} logMessage={logMessage} />}
            {editProfileModalToggler.isToggled && <SettingsEditModal toggler={editProfileModalToggler} user={user} isMainUser={true} logMessage={logMessage} />}
            {createUserModalToggler.isToggled && <SettingsCreateUserModal toggler={createUserModalToggler} logMessage={logMessage} resetList={resetListToggler} />}
            {createCategoryModalToggler.isToggled && <SettingsCreateCategoryModal toggler={createCategoryModalToggler} logMessage={logMessage} resetList={resetListToggler} />}
            {createSiteModalToggler.isToggled && <SettingsCreateSiteModal toggler={createSiteModalToggler} logMessage={logMessage} resetList={resetListToggler} />}
            {createConditionModalToggler.isToggled && <SettingsCreateConditionsModal toggler={createConditionModalToggler} logMessage={logMessage} resetList={resetListToggler} />}
            {createReturnRulesModalToggler.isToggled && <SettingsCreateReturnRulesModal toggler={createReturnRulesModalToggler} logMessage={logMessage} resetList={resetListToggler} />}
            {createShippingRulesModalToggler.isToggled && <SettingsCreateShippingRulesModal toggler={createShippingRulesModalToggler} logMessage={logMessage} resetList={resetListToggler} />}
            {createPaymentRulesModalToggler.isToggled && <SettingsCreatePaymentRulesModal toggler={createPaymentRulesModalToggler} logMessage={logMessage} resetList={resetListToggler} />}
            {createSupplierModalToggler.isToggled && <SettingsCreateSupplierModal toggler={createSupplierModalToggler} logMessage={logMessage} resetList={resetListToggler} />}
            {createManufacturersModalToggler.isToggled && <SettingsCreateManufacturersModal toggler={createManufacturersModalToggler} logMessage={logMessage} resetList={resetListToggler} />}
            {createVendorModalToggler.isToggled && <SettingsCreateVendorModal toggler={createVendorModalToggler} logMessage={logMessage} resetList={resetListToggler} />}
            <form onSubmit={deleteUserForm.handleSubmit(onDeleteUserSubmit)}>
                {deleteUserModalToggler.isToggled && (
                    <DeleteModal id='modal' toggler={deleteUserModalToggler} register={deleteUserForm.register} reset={deleteUserForm.reset} user={userTreated} deleteType={'user'} />
                )}
            </form>

            <MyNavigator path={`/offers`} trigger={navigateNow} />
            {(!isMobile || menuToggler.isToggled) && <SideBar toggler={menuToggler} />}
            <div>
                {isMobile && <NavBar toggler={menuToggler} />}
                <div
                    className={`page-content ${isMobile && menuToggler.isToggled ? (menuToggler.isToggledSecondary ? 'slide-right' : 'slide-left') : ''}`}
                    style={{
                        maxWidth: isMobile ? '' : 'calc(100vw - 256px)',
                        minWidth: isMobile ? '' : '1105px',
                        marginLeft: isMobile ? (menuToggler.isToggled ? '256px' : '') : '256px',
                        display: anyModalOpen && isMobile ? 'none' : '',
                    }}
                >
                    {logMessage.isToggled && (
                        <LogMessage
                            text={{
                                subject: logMessage.message.subject,
                                other_text: logMessage.message.other_text,
                                complement: logMessage.message.complement,
                            }}
                            bgColor={logMessage.message.bgColor}
                        />
                    )}
                    <div
                        className='header-box'
                        style={{
                            width: isMobile ? '345px' : '',
                        }}
                    >
                        <p className={isMobile ? `titlePage-Mob` : `titlePage`}>Settings</p>
                        <div style={{ display: 'flex', gap: 30, alignItems: 'center' }}>
                            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                                <p className='client-details-card-info-spec-value'>Security check</p>
                                <label className='switch'>
                                    <input type='checkbox' checked={securityCheckEnabled ? true : false} onChange={(value) => submitSecurityCheck(value?.target?.checked)} />
                                    <span className='toggle round'></span>
                                </label>
                            </div>
                            <button
                                className='button1'
                                type='submit'
                                onClick={editProfileModalToggler.toggle}
                                style={{
                                    width: isMobile ? '66px' : '122px',
                                }}
                            >
                                <img className='white' src={`${toIcons}/edit.svg`} />
                                {!isMobile && <p className='button1-text'>Edit</p>}
                            </button>
                        </div>
                    </div>
                    <div
                        className='settings-card shadow'
                        style={{
                            width: isMobile ? '345px' : '',
                            margin: isMobile ? '28px 15px' : '',
                            height: isMobile ? '345px' : '',
                        }}
                    >
                        <div
                            className='settings-card-content-wrapper'
                            style={{
                                margin: isMobile ? '48px 20px' : '',
                            }}
                        >
                            <div
                                className='settings-card-header'
                                style={{
                                    flexDirection: isMobile ? 'column' : 'row',
                                    alignItems: isMobile ? 'flex-start' : '',
                                }}
                            >
                                <p
                                    className='model-details-card-info-name'
                                    style={{
                                        fontSize: isMobile ? '32px' : '',
                                    }}
                                >{`${user?.name}`}</p>
                                {isAdmin && (
                                    <div className='settings-card-header-role-box'>
                                        <p className='settings-card-header-role'>{role}</p>
                                    </div>
                                )}
                            </div>
                            <div className='settings-card-info-box'>
                                <p className='settings-card-info-description'>Your login data</p>
                                <div
                                    className='client-details-card-row'
                                    style={{
                                        flexDirection: isMobile ? 'column' : 'row',
                                        gap: isMobile ? '25px' : '',
                                    }}
                                >
                                    <div className='client-details-card-info-spec-box'>
                                        <p className='client-details-card-info-spec-field'>E-mail</p>
                                        <p className='client-details-card-info-spec-value'>{user?.email}</p>
                                    </div>
                                    <div className='client-details-card-info-spec-box'>
                                        {/* <p className='client-details-card-info-spec-field'>Password</p> */}
                                        <input
                                            className='client-details-card-info-spec-value'
                                            type={'password'}
                                            value={
                                                user?.password
                                                    ? user?.password.slice(
                                                          /* slice only for better aesthetics, no utility */
                                                          0,
                                                          user?.password.length / 3
                                                      )
                                                    : ''
                                            }
                                            disabled={true}
                                            style={{
                                                boxShadow: 'none',
                                                marginTop: '-5px',
                                                backgroundColor: 'transparent',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {isAdmin && <UsersTable {...user} toggler={createUserModalToggler} deleteToggler={deleteUserModalToggler} resetList={resetListToggler} logMessage={logMessage} />}
                    {isAdmin && <Categories {...user} toggler={createCategoryModalToggler} deleteToggler={deleteUserModalToggler} resetList={resetListToggler} logMessage={logMessage} />}
                    {isAdmin && <ShippingRules {...user} toggler={createShippingRulesModalToggler} deleteToggler={deleteUserModalToggler} resetList={resetListToggler} logMessage={logMessage} />}
                    {isAdmin && <Conditions {...user} toggler={createConditionModalToggler} deleteToggler={deleteUserModalToggler} resetList={resetListToggler} logMessage={logMessage} />}
                    {isAdmin && <ReturnRules {...user} toggler={createReturnRulesModalToggler} deleteToggler={deleteUserModalToggler} resetList={resetListToggler} logMessage={logMessage} />}
                    {isAdmin && <PaymentRules {...user} toggler={createPaymentRulesModalToggler} deleteToggler={deleteUserModalToggler} resetList={resetListToggler} logMessage={logMessage} />}
                    {isAdmin && <Sites {...user} toggler={createSiteModalToggler} deleteToggler={deleteUserModalToggler} resetList={resetListToggler} logMessage={logMessage} />}
                    {isAdmin && <Manufacturers {...user} toggler={createManufacturersModalToggler} deleteToggler={deleteUserModalToggler} resetList={resetListToggler} logMessage={logMessage} />}
                    {isAdmin && <Suppliers {...user} toggler={createSupplierModalToggler} deleteToggler={deleteUserModalToggler} resetList={resetListToggler} logMessage={logMessage} />}
                    {isAdmin && <Vendors {...user} toggler={createVendorModalToggler} resetList={resetListToggler} logMessage={logMessage} />}
                    {isAdmin && <ChangeSites />}
                    {isAdmin && <ContoVendita />}
                    <div style={{ width: isMobile ? '345px' : '1056.1px' }}>
                        <button
                            className='calendar-cta shadow'
                            style={{
                                justifySelf: 'flex-start',
                                width: '101px',
                                marginTop: isMobile ? '15px' : '34px',
                            }}
                            onClick={logoutToggler.toggle}
                        >
                            <p className='calendar-cta-text offLightBlue'>Log out</p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SettingsPage;
